import { Component } from '@angular/core';
import { AlertController, NavController, NavParams, ViewController } from 'ionic-angular';
import { FormGroup } from "@angular/forms";
import { ApiService } from "../../services/api.service";
import { ReportCustomerClientPage } from "../report-customer-client/report-customer-client";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";

@Component({
  selector: 'page-report-search-customer',
  templateUrl: 'report-search-customer.html',
})
export class ReportSearchCustomerPage {

  searchPerformed = false;
  busy = false;
  clientForm: FormGroup;
  locationForm: FormGroup;
  invoiceForm: FormGroup;
  externalForm: FormGroup;
  page: ReportCustomerClientPage;
  data: any;

  query = '';
  customers = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    public barcodeScanner: BarcodeScanner,
    public apiService: ApiService
  ) {
    this.clientForm = navParams.get('clientForm');
    this.locationForm = navParams.get('locationForm');
    this.invoiceForm = navParams.get('invoiceForm');
    this.externalForm = navParams.get('externalForm');
    this.page = navParams.get('page');
    this.data = navParams.get('data');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportSearchLocationPage');
  }

  isValid(){
    if(this.query.trim()){
      return true;
    }
    return false;
  }

  search(){
    if(!this.isValid()){
      return;
    }
    this.searchPerformed = false;
    this.customers = [];
    this.busy = true;
    this.apiService.searchCustomer(this.query, 3).then((data) => {
      // @ts-ignore
      this.customers = data;
      this.busy = false;
      this.searchPerformed = true;
    }).catch((error_code) => {
      this.busy = false;
      this.searchPerformed = true;
      let msg = 'Er is iets mis gegaan bij het communiceren met de server. Controleer uw internetverbinding.';
      if(error_code < 0) msg = 'Er is iets mis gegaan bij het communiceren met de server (' + (error_code * -1) + ')';
      this.alertCtrl.create({
        title: 'Fout',
        message: msg,
        buttons: ['OK']
      }).present();
    });
  }

  select(customer){
    let customerType = 'external';
    if(customerType == 'external'){
      customer._requires_action = '1';
      this.externalForm.patchValue(customer);
      this.page.externalExpanded = true;
      this.externalForm.markAsPristine();
      this.data.customers.external = customer;
      this.data._selected_customers.external = customer;
    }
    this.closeModal();
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-search-customer/report-search-customer.ts